import React, { useState } from "react";

//Import Breadcrumb
import { Icon } from "@iconify/react/dist/iconify.js";
import { Grid } from "@mui/material";
import { connect } from 'react-redux';
import AppDialog from "../../components/Common/AppDialog.js";
import Label from "../../components/Common/Label.js";
import Helpers from "../../helpers/helpers.js";
import moment from "moment";


const LoanApplicationDetails = ({ detailsOpen, setDetailsOpen, setFormValues, supportDetails, values, setNotification, error }) => {

    // const supportDetails = {
    //     applicant?.email: "john.doe@example.com",
    //     subject: "Issue with product installation",
    //     description: "I am having trouble installing the windshield deflector on my motorcycle. The mounting brackets don't seem to align properly with the handlebar clamps. I've followed the instruction manual but still facing difficulties.",
    //     attachment: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQW8O39ESMIVAKdxWb71YtlE12X6z99gVVaCA&s",
    //     status: "pending",
    //     reference_no: "SUP-2024-001234",
    //     reportedOn: "2024-12-10T14:30:00",
    //     applicant?.name: "John Doe",
    //     applicant?.phone: "+60123456789"
    // } //dummy

    const renderContent = () => {
        return (
            <div>
                <Grid container spacing={2} sx={{ paddingLeft: 1 }}>
                    <Grid item xs={12}>
                        <div className="section-header text-semibold mb-3">Application Details</div>
                        <Grid container spacing={1.5}>
                            <Grid item xs={12}>
                                <Grid container>
                                    <Grid item xs={12} md={4}>
                                        <div className="subheader-2">
                                            <Icon icon="fluent:tag-20-regular" className="me-2" />Vehicle
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                        <div>{supportDetails?.vehicle || '-'}</div>
                                        <div className="subheader-2">{supportDetails?.dealer}</div>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container>
                                    <Grid item xs={12} md={4}>
                                        <div className="subheader-2">
                                            <Icon icon="fluent:building-bank-20-regular" className="me-2" />Finance Company
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                        {supportDetails?.finance_company || '-'}
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container>
                                    <Grid item xs={12} md={4}>
                                        <div className="subheader-2">
                                            <Icon icon="fluent:money-20-regular" className="me-2" />Est. Loan Amount
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                        ${supportDetails?.loan_amount || '-'}
                                    </Grid>
                                </Grid>
                            </Grid>


                            <Grid item xs={12} sx={{ alignItems: 'center' }}>
                                <Grid container>
                                    <Grid item xs={12} md={4}>
                                        <div className="subheader-2">
                                            <Icon icon="fluent:bookmark-20-regular" className="me-2" />Status
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                        <Label.GeneralStatusLabel label={supportDetails?.status} list={Helpers.loanApplicationStatus} marginLeft={"0px"} />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container>
                                    <Grid item xs={12} md={4}>
                                        <div className="subheader-2">
                                            <Icon icon="fluent:document-page-number-20-regular" className="me-2" />Ref. No.
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                        #{supportDetails?.reference_no || '-'}
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container>
                                    <Grid item xs={12} md={4}>
                                        <div className="subheader-2">
                                            <Icon icon="ri-file-list-line" className="me-2" />Application ID
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                        #{supportDetails?.application_id || '-'}
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container>
                                    <Grid item xs={12} md={4}>
                                        <div className="subheader-2">
                                            <Icon icon="fluent:calendar-empty-20-regular" className="me-2" />Submitted On
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                        {supportDetails?.submitted_at ? moment(supportDetails?.submitted_at).format("DD MMM YYYY HH:mm A") : '-'}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sx={{ marginTop: 3 }}>
                        <div className="section-header text-semibold mb-3">Applicant Details</div>
                        <Grid container spacing={1.5}>
                            <Grid item xs={12}>
                                <Grid container>
                                    <Grid item xs={12} md={4}>
                                        <div className="subheader-2">
                                            <Icon icon="fluent:person-20-regular" className="me-2" />Name
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                        {supportDetails?.applicant?.name || '-'}
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container>
                                    <Grid item xs={12} md={4}>
                                        <div className="subheader-2">
                                            <Icon icon="fluent:call-16-regular" className="me-2" />Phone number
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={8}>
                                        {supportDetails?.applicant?.phone || '-'}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        );
    }

    return (
        <React.Fragment>
            <AppDialog
                open={detailsOpen}
                close={() => setDetailsOpen(false)}
                title={`Application Details #${supportDetails?.reference_no || '-'}`}
                buttonSpaceBetween={false}
                positiveTitle={"Close"}
                positivePress={() => { setDetailsOpen(false) }}
                width={'50%'}
            >
                {renderContent()}
            </AppDialog>
        </React.Fragment>
    );
};

function mapStateToProps({ Login, General, Dealer }) {
    return {
        userListing: Dealer?.userListing,
        addUser: Dealer?.addUser,
        editUser: Dealer?.editUser,
        delUser: Dealer?.delUser,
        editUserActivation: Dealer?.editUserActivation,
        editUserDepartment: Dealer?.editUserDepartment,
        userData: Login?.verifyAdmin?.user?.data,
        exportExcel: Dealer?.exportExcel,
        departmentList: General?.department_list,
        roleList: General?.role_list,
        teamList: General?.team_list,
        userPermission: Login.permissionArry,
    };
}


export default connect(mapStateToProps)(LoanApplicationDetails);
